import {ActionTree} from 'vuex';
import {RootState} from '@/store/types';
import {ContentStateInterface, IssueStepInterface} from '@/store/modules/content/types';
import {cms} from '@/services/http';
import {AxiosError, AxiosResponse} from 'axios';

export const actions: ActionTree<ContentStateInterface, RootState> = {
  async fetchBlocks({commit}: {commit: any}): Promise<void> {
    return cms.axios.get('api/issue-tracker/blocks').then((response: AxiosResponse) => {
      commit('updateBlocks', response.data);
    }, (err: AxiosError) => {
      // todo: handle errors
    });
  },
  async fetchSteps({commit}: {commit: any}): Promise<void> {
    return cms.axios.get('api/issue-tracker/issue-steps').then(
      (response: AxiosResponse) => {
        commit('updateSteps', response.data);
      },
      (err: AxiosError) => {
        // todo: handle exception
      });
  },
};
